import React, { useState } from "react";
import axios from "axios";
import { SPINWHEEL_MODULES } from "./useSpinwheelDim";

export default function useSpinwheelVerification(authToken, finishHandler = () => {}) {
	async function initIdVerification(forceNew = false) {
		try {
			const idConnectedResp = await axios.get('/spinwheel/get-identity-connected', {
				headers: { 'Auth-token': authToken }
			});
			if (idConnectedResp.data && idConnectedResp.data.connected) {
				finishHandler(true);
				return true;
			}
		} catch (e) {
			console.log(e);
		}
		finishHandler(false);
		return false;
	}

	return initIdVerification;
}
